import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getDoneWorkControlMetrics(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_CONTROL_METRICS,
		ModulesConfigMap[ModulesMap.DONE_WORKS_CONTROL_METRICS].GET_DONE_WORKS_CONTROL_METRICS,
		options
	)
}
function _getDoneWorkControlMetricPreview(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_CONTROL_METRICS,
		ModulesConfigMap[ModulesMap.DONE_WORKS_CONTROL_METRICS].GET_DONE_WORKS_CONTROL_METRIC_PREVIEW,
		options
	)
}
function _getDoneWorkControlMetricPopup(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_CONTROL_METRICS,
		ModulesConfigMap[ModulesMap.DONE_WORKS_CONTROL_METRICS].GET_DONE_WORKS_CONTROL_METRIC_POPUP,
		options
	)
}

function _createDoneWorkControlMetric(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_CONTROL_METRICS,
		ModulesConfigMap[ModulesMap.DONE_WORKS_CONTROL_METRICS].CREATE_DONE_WORKS_CONTROL_METRIC,
		options
	)
}

function _getDoneWorkControlMetric(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_CONTROL_METRICS,
		ModulesConfigMap[ModulesMap.DONE_WORKS_CONTROL_METRICS].GET_DONE_WORKS_CONTROL_METRIC,
		options
	)
}

function _patchDoneWorkControlMetric(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_CONTROL_METRICS,
		ModulesConfigMap[ModulesMap.DONE_WORKS_CONTROL_METRICS].PATCH_DONE_WORKS_CONTROL_METRIC,
		options
	)
}

function _patchDoneWorkControlMetricBulkUpdate(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_CONTROL_METRICS,
		ModulesConfigMap[ModulesMap.DONE_WORKS_CONTROL_METRICS].PATCH_DONE_WORKS_CONTROL_METRIC_BULK_UPDATE,
		options
	)
}

function _putDoneWorkControlMetric(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_CONTROL_METRICS,
		ModulesConfigMap[ModulesMap.DONE_WORKS_CONTROL_METRICS].PUT_DONE_WORKS_CONTROL_METRIC,
		options
	)
}

function _deleteDoneWorkControlMetric(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_CONTROL_METRICS,
		ModulesConfigMap[ModulesMap.DONE_WORKS_CONTROL_METRICS].DELETE_DONE_WORKS_CONTROL_METRIC,
		options
	)
}



export default {
	[ModulesConfigMap[ModulesMap.DONE_WORKS_CONTROL_METRICS].GET_DONE_WORKS_CONTROL_METRICS]: _getDoneWorkControlMetrics,

	[ModulesConfigMap[ModulesMap.DONE_WORKS_CONTROL_METRICS].GET_DONE_WORKS_CONTROL_METRIC_PREVIEW]: _getDoneWorkControlMetricPreview,
	[ModulesConfigMap[ModulesMap.DONE_WORKS_CONTROL_METRICS].GET_DONE_WORKS_CONTROL_METRIC_POPUP]: _getDoneWorkControlMetricPopup,

	[ModulesConfigMap[ModulesMap.DONE_WORKS_CONTROL_METRICS].CREATE_DONE_WORKS_CONTROL_METRIC]: _createDoneWorkControlMetric,
	[ModulesConfigMap[ModulesMap.DONE_WORKS_CONTROL_METRICS].GET_DONE_WORKS_CONTROL_METRIC]: _getDoneWorkControlMetric,
	[ModulesConfigMap[ModulesMap.DONE_WORKS_CONTROL_METRICS].PATCH_DONE_WORKS_CONTROL_METRIC]: _patchDoneWorkControlMetric,
	[ModulesConfigMap[ModulesMap.DONE_WORKS_CONTROL_METRICS].PATCH_DONE_WORKS_CONTROL_METRIC_BULK_UPDATE]: _patchDoneWorkControlMetricBulkUpdate,
	[ModulesConfigMap[ModulesMap.DONE_WORKS_CONTROL_METRICS].PUT_DONE_WORKS_CONTROL_METRIC]: _putDoneWorkControlMetric,
	[ModulesConfigMap[ModulesMap.DONE_WORKS_CONTROL_METRICS].DELETE_DONE_WORKS_CONTROL_METRIC]: _deleteDoneWorkControlMetric,
}
